/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Scope_Point_3Inputs */

const en_svc_integration_scope_point_3 = /** @type {(inputs: Svc_Integration_Scope_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM integration into internal tools and customer portals`)
};

const lv_svc_integration_scope_point_3 = /** @type {(inputs: Svc_Integration_Scope_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LLM integrācija iekšējos rīkos un klientu portālos`)
};

/**
* | output |
* | --- |
* | "LLM integration into internal tools and customer portals" |
*
* @param {Svc_Integration_Scope_Point_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_scope_point_3 = /** @type {((inputs?: Svc_Integration_Scope_Point_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Scope_Point_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_scope_point_3(inputs)
	return en_svc_integration_scope_point_3(inputs)
});